import { Reducer } from 'redux';

import { IErrorActionData } from '../../../models/Error';
import { AddCmsSlipActions, AddCmsSlipActionTypes } from '../actions/AddCmsSlip';

export interface IAddCmsSlipState {
  isSuccess: boolean;
  isProcessing: boolean;
  error?: IErrorActionData;
}

const initialAddCmsSlipState: IAddCmsSlipState = {
  isSuccess: false,
  isProcessing: false,
  error: undefined,
};

const AddCmsSlipReducer: Reducer<IAddCmsSlipState, AddCmsSlipActions> = (
  state = initialAddCmsSlipState,
  action: AddCmsSlipActions,
): IAddCmsSlipState => {
  switch (action.type) {
    case AddCmsSlipActionTypes.ADD_CMS_SLIP_ACTION:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case AddCmsSlipActionTypes.ADD_CMS_SLIP_ACTION_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };

    case AddCmsSlipActionTypes.ADD_CMS_SLIP_ACTION_FAILURE:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case AddCmsSlipActionTypes.ADD_CMS_SLIP_ACTION_RESET:
      return initialAddCmsSlipState;

    default:
      return state;
  }
};

export default AddCmsSlipReducer;
